export enum TeamTabs {
  members = 'members',
  rights = 'rights',
  settings = 'settings',
}
